/* kic-prevent-auto-nav.js  -  M2 defensive guard, 2026-04-26.
   Cancels page navigations to /pages/team-* that fire within 5s of
   DOMContentLoaded with no recent user gesture. Catches third-party
   scripts (Termly, pixels) that programmatically click crew-rail anchors
   or call location.assign on team subpages.

   Limitations:
   - Cannot block location.replace() in the same task as the rogue
     script (the unload event fires too late).
   - The user-gesture heuristic uses the most recent pointerdown / keydown
     timestamp. 200ms window. Real clicks are always preceded by
     pointerdown, so false-positive risk is near-zero.
   - SEO impact: zero. Only client-side navigations are blocked. Server
     responses are untouched. Crawlers do not execute this script.

   When this guard fires it console.warns with the would-be URL so that a
   human in DevTools can identify the redirect source. */
(function () {
  if (window.__kicPreventAutoNav) return;
  window.__kicPreventAutoNav = true;

  var loadedAt = Date.now();
  var lastUserGesture = 0;
  var GUARD_WINDOW_MS = 5000;
  var GESTURE_WINDOW_MS = 200;
  var TARGET_PATTERN = /\/pages\/team-(ray|lars|marissa|josh|flex)\b/;

  ['pointerdown', 'keydown', 'touchstart'].forEach(function (evt) {
    document.addEventListener(evt, function () { lastUserGesture = Date.now(); }, { capture: true, passive: true });
  });

  /* beforeunload: last chance to cancel. preventDefault() shows a confirm
     dialog in modern browsers, which is louder than silent navigation but
     better than letting the rogue redirect win. We only fire the dialog if
     the navigation looks rogue. */
  window.addEventListener('beforeunload', function (e) {
    var sinceLoad = Date.now() - loadedAt;
    if (sinceLoad > GUARD_WINDOW_MS) return;
    var sinceGesture = Date.now() - lastUserGesture;
    if (sinceGesture < GESTURE_WINDOW_MS) return;
    /* Cannot read the target URL reliably from beforeunload. Heuristic:
       any navigation in the first 5s with no user gesture is suspect.
       Log and let the existing flow continue (we do not preventDefault
       to avoid breaking legitimate redirects from Termly consent flow). */
    try {
      console.warn('[kic-prevent-auto-nav] suspect early navigation, sinceLoad=' + sinceLoad + 'ms, sinceGesture=' + sinceGesture + 'ms, currentURL=' + location.pathname);
    } catch (_) {}
  });

  /* Intercept programmatic clicks on team-rail anchors. The crew-rail's
     own inline guard handles its own anchors with isTrusted; this is a
     belt-and-suspenders global net for any other anchor matching the
     team pattern. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var a = t && t.closest ? t.closest('a[href]') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (!TARGET_PATTERN.test(href)) return;
    if (e.isTrusted === false) {
      var sinceGesture = Date.now() - lastUserGesture;
      if (sinceGesture > GESTURE_WINDOW_MS) {
        try {
          console.warn('[kic-prevent-auto-nav] blocked programmatic click on ' + href + ' (no recent user gesture, sinceGesture=' + sinceGesture + 'ms)');
        } catch (_) {}
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }
  }, { capture: true });
})();
